import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70c3c63b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-comment-editor" }
const _hoisted_2 = { class: "editor-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_textarea, {
      value: _ctx.draft,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
      maxlength: 200,
      placeholder: _ctx.generateTitle('请输入备注/留言信息'),
      "auto-size": { minRows: 2, maxRows: 5 },
      "show-count": ""
    }, null, 8, ["value", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        type: "primary",
        size: "small",
        loading: _ctx.saving,
        disabled: !_ctx.canSave,
        onClick: _ctx.saveComment
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.generateTitle('保存')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ])
  ]))
}